var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMomo = function SvgMomo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M4.75 10.5a.75.75 0 0 1 .75-.75h25.8a.75.75 0 0 1 .75.75v15.9a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#BFBFBF",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2,
    d: "M6.35 10.25a1.1 1.1 0 0 0-1.1 1.1v14.2a1.1 1.1 0 0 0 1.1 1.1h24.1a1.1 1.1 0 0 0 1.1-1.1v-14.2a1.1 1.1 0 0 0-1.1-1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.25 18a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3m0-1.575a1.575 1.575 0 1 0 0-3.15 1.575 1.575 0 0 0 0 3.15",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.303 14.5V18h1.91v-3.5c0-.627.117-1.273.89-1.273 1.018 0 1.018.86 1.018 1.273V18h2.291v-3.5c0-.7.143-1.273.891-1.273s.94.48.94 1.273V18h1.86v-3.5c0-1.724-1.05-2.8-2.8-2.8-1.12 0-1.867.467-2.1.7-.233-.233-.98-.7-2.1-.7-1.75 0-2.87 1.4-2.8 2.8M10.303 21.7v3.5h1.91v-3.5c0-.627.117-1.273.89-1.273 1.018 0 1.018.86 1.018 1.273v3.5h2.291v-3.5c0-.7.143-1.273.891-1.273s.94.48.94 1.273v3.5h1.86v-3.5c0-1.724-1.05-2.8-2.8-2.8-1.12 0-1.867.467-2.1.7-.233-.233-.98-.7-2.1-.7-1.75 0-2.87 1.4-2.8 2.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.25 25.2a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3m0-1.575a1.575 1.575 0 1 0 0-3.15 1.575 1.575 0 0 0 0 3.15",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 9h2v1h-2zM24 27h3v1h-3z"
  })));
};
export default SvgMomo;